<template>
    <div>
        <div class="describe"></div>
        <el-form
            ref="ruleForm"
            :model="ruleForm"
            :rules="rules"
            label-width="120px"
            class="demo-ruleForm"
            hide-required-asterisk
        >
            <el-form-item label="输入新密码：" prop="newPassword">
                <el-input
                    v-model.trim="ruleForm.newPassword"
                    type="password"
                    placeholder="请以字母开头,6至16个字符"
                ></el-input>
            </el-form-item>
            <el-form-item label="确认新密码：" prop="confirmPwd">
                <el-input
                    v-model.trim="ruleForm.confirmPwd"
                    type="password"
                    placeholder="请以字母开头,6至16个字符"
                ></el-input>
            </el-form-item>
        </el-form>
        <div class="but-item">
            <el-button round size="small" style="width:240px;margin-right:40px;height:44px" @click="next('back')"
                >上一步</el-button
            >
            <el-button round type="primary" size="small" style="width:240px; height:44px" @click="next"
                >下一步</el-button
            >
        </div>
    </div>
</template>
<script>
import AES from "@/libs/secret";

export default {
    props: {
        type: {
            type: Number,
            default: 0,
        },
        data: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        let validatePass2 = (rule, value, callback) => {
            if (value !== this.ruleForm.newPassword) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            ruleForm: {
                source: "PS",
                fieldName: this.data.fieldName,
                codeNumber: this.data.codeNumber,
                notify: this.type === 1 ? "SMS" : "EMAIL",
                newPassword: "",
                confirmPwd: "",
                ifEncrypt: true,
            },
            rules: {
                newPassword: [
                    {
                        required: true,
                        message: "请输入密码",
                        trigger: "blur",
                    },
                    {
                        pattern: /^[A-Za-z](?=.*\d)[A-Za-z\d$@$!%*#?&]{5,19}$/,
                        message: "请以字母开头,6至16个字符",
                        trigger: "blur",
                    },
                ],
                confirmPwd: [
                    {
                        required: true,
                        message: "请确认密码",
                        trigger: "blur",
                    },
                    {
                        pattern: "",
                        message: "两次输入密码不一致",
                        trigger: "blur",
                    },
                    {
                        pattern: /^[A-Za-z](?=.*\d)[A-Za-z\d$@$!%*#?&]{5,19}$/,
                        message: "请以字母开头,6至16个字符",
                        trigger: "blur",
                    },
                    { validator: validatePass2, trigger: "blur" },
                ],
            },
        };
    },
    watch: {
        "ruleForm.confirmPwd"(val, oldVal) {
            if (val !== oldVal) {
                this.rulesform();
            }
        },
    },
    created() {},
    mounted() {},
    methods: {
        next(type) {
            if (type === "back") {
                this.$emit("next", type);
                this.$emit("backData", this.data);
                return;
            }
            // else {
            //     this.$emit("goNext", 3);
            // }
            this.rulesform(type);
            if (this.flag) {
                this.data.newPassword = this.ruleForm.confirmPwd;
                let formData = { ...this.data };
                formData.ifEncrypt = true;
                formData.newPassword = AES.Encrypt(formData.newPassword);
                this.$axios.post("/uc/account/find/pass", formData).then(() => {
                    this.$message.success("修改密码成功");
                    this.$emit("next", type);
                });
            }
        },
        rulesform() {
            this.flag = false;
            this.rules.confirmPwd[1].pattern = this.ruleForm.newPassword;
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    this.flag = true;
                } else {
                    return false;
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.describe {
    color: $primary;
    padding-left: 15px;
    margin-bottom: 15px;
}
.but-item {
    margin: 72px 0 0;
    text-align: center;
}

.title {
    color: #70829a;
    margin: 50px 0 30px;
}
</style>
<style lang="scss">
.demo-ruleForm {
    .el-button--mini {
        width: 72px;
        height: 28px;
        line-height: 28px;
        padding: 0 !important;
        text-align: center;
    }
}
</style>
